var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"typeform"},[_c('div',{ref:"typeform__embed",staticClass:"typeform__embed",attrs:{"id":"typeform__embed"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }